import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { AllProjectDeliveriesDataGrid } from "src/components/views/erp/project/delivery/AllProjectDeliveriesDataGrid.tsx";

export const Route = createFileRoute("/_authenticated/_shell/project/delivery/allDeliveries")({
	staticData: { title: i18n.t("all_deliveries"), legacyViewKey: "allProjectDeliveriesPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <AllProjectDeliveriesDataGrid />;
}
